import SEO from '../components/SEO/SEO';
import Brands from '../components/AllLogoSection/Brands';
import Experience from '../components/ExperienceSection/Experience';
import Quote from '../components/QuoteSection/Quote';
import FAQs from './../components/FAQsSection/FAQs';
import ServicesSection from '../components/ServicesSection/ServicesSection';
import LatestArticles from '../components/LatestArticles/LatestArticles';
import Make from './../components/MakeSection/Make';
import HeroSection from '../components/HeroSection/HeroSection';
import { usePageSEO } from '../hooks/usePageSEO';

const Home = () => {
  const seo = usePageSEO('home');

  return (
    <>
      <SEO
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        type={seo.type}
        noIndex={seo.noIndex}
        noFollow={seo.noFollow}
      />
      <HeroSection page="HomePage" showRecentWork={true} showMoreButton={true} />
      <ServicesSection page="HomePage" />
      <Experience />
      <Brands />
      <Quote page="HomePage" />
      <FAQs page='homePage' />
      <LatestArticles />
      <Make pageKey="homePage" />
    </>
  );
};

export default Home;